import type { FmWorkOrderDto } from '../services-work-order.models';
import type { ChecklistDraftEntry } from '../fm-work-order-checklist.util';

export const WO_OFFLINE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export interface WoOfflineCacheEntry {
  workOrderId: number;
  organizationId: number;
  projectId: number;
  cachedAt: string;
  workOrder: FmWorkOrderDto;
}

export interface WoChecklistDraftsStored {
  workOrderId: number;
  organizationId: number;
  projectId: number;
  updatedAt: string;
  drafts: Record<number, ChecklistDraftEntry>;
}

export interface OutboxPhotoUploadOp {
  type: 'PHOTO_UPLOAD';
  order: number;
  localPath: string;
  contentType: string;
}

export interface OutboxSubmitOp {
  type: 'SUBMIT';
}

export type OutboxOp = OutboxPhotoUploadOp | OutboxSubmitOp;

export interface WoOutboxEntry {
  workOrderId: number;
  organizationId: number;
  projectId: number;
  userId: string;
  createdAt: string;
  ops: OutboxOp[];
  /** Completion comment for work orders raised from a service ticket. */
  completionComment?: string | null;
  lastError?: string | null;
  deadLetteredAt?: string | null;
}

export type WoSyncBannerState = 'online' | 'offline' | 'pending' | 'syncing' | 'failed' | 'dead_letter';
